import { useQuery } from "@tanstack/react-query";
import clsx from "clsx";
import { ScrollRestoration, useOutlet, useParams } from "react-router-dom";
import notificationApi from "@/api/notification";
import { LoadingPage } from "@/components/LoadingPage/LoadingPage";
import { Navigation } from "@/components/Navigation/Navigation";
import { DesktopOnly } from "@/components/Responsive/DesktopOnly";
import { useAppData } from "@/hooks/useAppData";
import { useNotifications } from "@/hooks/useNotification";
import { useTenantData } from "@/hooks/useTenantData";
import {
    getIsAResumePreviewPage,
    getIsPreferencesPage,
    getIsPreviewPage,
    getIsProfilePage,
    getIsResumePage,
} from "@/utils/routes";

export const AppLayout = () => {
    const outlet = useOutlet();
    const isResumePage = getIsResumePage();
    const isAResumePreviewPage = getIsAResumePreviewPage();
    const isPreferencesPages = getIsPreferencesPage();
    const isPreviewPage = getIsPreviewPage();
    const isProfilePage = getIsProfilePage();
    const params = useParams();
    const { isLoading: isAppDataLoading } = useAppData(params.id, isResumePage);
    const { isLoading: isTenantLoading } = useTenantData();
    const { data: pendingNotifications } = useQuery({
        queryKey: ["pendingNotifications"],
        queryFn: () => notificationApi.getPendingNotifications(),
    });
    useNotifications(pendingNotifications);

    return isAppDataLoading || isTenantLoading ? (
        <LoadingPage />
    ) : (
        <>
            <div
                className={clsx(
                    "relative bg-neutral-100",
                    (isAResumePreviewPage || isPreviewPage || isProfilePage) &&
                        "min-h-full",
                )}
            >
                {isResumePage && <DesktopOnly />}
                {!isPreferencesPages && <Navigation />}
                <div
                    className={clsx(
                        isResumePage ? "bg-neutral-100" : "",
                        "relative",
                    )}
                >
                    <ScrollRestoration />
                    {outlet}
                </div>
            </div>
        </>
    );
};
